import React, { createContext, useContext, useState, useEffect } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [isNavigationCollapsed, setIsNavigationCollapsed] = useState(false);

  // Load navigation collapsed state from localStorage on component mount
  useEffect(() => {
    const stored = localStorage.getItem('isNavigationCollapsed');
    if (stored) {
      try {
        setIsNavigationCollapsed(JSON.parse(stored));
      } catch (error) {setIsNavigationCollapsed(false);
      }
    }
  }, []);

  // Save navigation collapsed state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('isNavigationCollapsed', JSON.stringify(isNavigationCollapsed));
  }, [isNavigationCollapsed]);

  const toggleNavigationCollapse = () => {
    setIsNavigationCollapsed(prev => !prev);
  };

  const collapseNavigation = () => {
    setIsNavigationCollapsed(true);
  };

  const expandNavigation = () => {
    setIsNavigationCollapsed(false);
  };

  const value = {
    isNavigationCollapsed,
    toggleNavigationCollapse,
    collapseNavigation,
    expandNavigation,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};